module.exports = __webpack_public_path__ + "static/media/59.1a741739.jpg";